import { DialogLike } from "@obg/mat.ui.core";
import { Timeout } from "@obg/ngx.core";

import { SelfExclusionType } from "../../self-exclusion.const";

import { SelfExclusionWarningContainer } from "./self-exclusion-warning.container";

export const SELF_EXCLUSION_WARNING_DIALOG_ID = "covid-message";

export function selfExclusionWarningDialogFactory(
	exclusionPeriod?: Timeout,
	centrallyExcluded?: boolean,
	selfExclusionType?: SelfExclusionType
): DialogLike<SelfExclusionWarningContainer> {
	return {
		dialogId: SELF_EXCLUSION_WARNING_DIALOG_ID,
		dialogComponentType: SelfExclusionWarningContainer,
		init: (c) => (
			(c.exclusionPeriod = exclusionPeriod),
			(c.selfExclusionType = selfExclusionType),
			(c.centrallyExcluded = centrallyExcluded)
		),
	};
}
